<div class="modal-container">
  <div class="d-flex flex-row align-items-center justify-content-between px-3">
    <span class="modal-title">Referral Code</span>
    <div class="close-btn" matRipple (click)="closeModal()">
      <img src="../../../../assets/icon/close_icon.svg" alt="close-icon" />
    </div>
  </div>
  <hr />
  <div class="d-flex flex-column px-3 pb-3" *ngIf="data">
    <div class="d-flex flex-column" *ngIf="data.referred_by == null">
      <span class="input-title">Enter a referral code</span>
      <input
        placeholder="Enter code"
        class="code-input"
        minlength="4"
        [(ngModel)]="code"
      />
      <button
        class="apply-code-btn"
        matRipple
        [disabled]="code.length < 4"
        (click)="applyCode()"
      >
        Apply Code
      </button>
    </div>
    <div class="referral-code-container py-3" *ngIf="data.referred_by">
      <div class="d-flex flex-column gap-1">
        <span class="title">Referred by</span>
        <span class="value">{{ data.referred_by.name }}</span>
      </div>
      <div class="d-flex flex-column gap-1">
        <span class="title">Referred on</span>
        <span class="value">{{
          data.referred_by.referred_on | date: "yyyy-MM-dd"
        }}</span>
      </div>
    </div>
    <hr />
    <span class="section-heading">Share your referral code</span>
    <div class="referral-code-container mt-3">
      <span class="code">{{ data.referral_code }}</span>
      <button class="copy-btn" matRipple (click)="copyText(data.referral_code)">
        <img
          class="clip-board-icon"
          src="assets/icon/clipboard-icon-white.svg"
          alt="clipboard-icon"
        />
        <span>Copy</span>
      </button>
    </div>
  </div>
</div>
